import { render, staticRenderFns } from "./GtsRoomSlider.vue?vue&type=template&id=72a750a7&scoped=true"
import script from "./GtsRoomSlider.vue?vue&type=script&lang=js"
export * from "./GtsRoomSlider.vue?vue&type=script&lang=js"
import style0 from "./GtsRoomSlider.vue?vue&type=style&index=0&id=72a750a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a750a7",
  null
  
)

export default component.exports